const errorsJson = {
  errorMandatory: 'Champs obligatoire',
  errorNumber: 'Champs obligatoire',
  errorNumberMin: min => `supérieur à ${min}`,
  errorNumberBetween: (min, max) => `entre ${min} et ${max}`,
  errorNumberMax: max => `inférieur à ${max}`,
  errorMax: 'Valeur trop grande',
  errorMail: 'Email invalide',
  errorPhone: 'Numéro de téléphone invalide',
  errorDigit: 'Nombre invalide',
  errorDecimal: 'Nombre décimal invalide'
}

export const constructError = object =>
  typeof object === 'object'
    ? errorsJson[object.key](...object.params)
    : errorsJson[object]



// WEBPACK FOOTER //
// ./src/services/errors.js